import React from 'react';
import classnames from 'classnames';
import type { HTMLAttributes } from 'react';
import { LoaderAnimationStyled, LoaderWrapperStyled } from './Loader.styled';
import { LOADER_ANIMATION, LOADER_LABEL, LOADER_WRAPPER } from '../../util/data-id';
import { useI18n } from '@whizz/react-i18n';

type Ref = HTMLDivElement;
type HTMLProps = HTMLAttributes<Ref>;
interface Props extends HTMLProps {
  /**
   * Loader message.
   */
  label?: string | React.ReactNode;
  /**
   * Hides label.
   */
  disableLabel?: boolean;
  smallSize?: boolean;
  noMargin?: boolean;
}

const Loader = React.forwardRef<Ref, Props>(({
  label,
  disableLabel,
  smallSize,
  noMargin = false,
  ...other
}: Props, ref) => {
  const { translate } = useI18n();
  label = label ?? translate('global.LOADING');
  return (
    <LoaderWrapperStyled ref={ref} data-id={LOADER_WRAPPER} role={'status'} noMargin={noMargin} {...other as HTMLProps}>
      <LoaderAnimationStyled data-id={LOADER_ANIMATION} smallSize={smallSize} />
      <div
        data-id={LOADER_LABEL}
        className={`${classnames({ 'sr-only': disableLabel })} block mx-auto my-sm`}
      >
        {label}
      </div>
    </LoaderWrapperStyled>
  );
});

Loader.displayName = 'Loader';

export default Loader;


